<template>
  <div class="sales-growth-university-slider-wrapper">
    <div class="sales-growth-university-slider mx-auto">
      <div ref="swiper" class="swiper">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div class="swiper-slide">
            <div class="fast-slider slide-1"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-2"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-3"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-4"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-5"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-6"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-7"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-8"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-9"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-10"> </div>
          </div>
          <div class="swiper-slide">
            <div class="fast-slider slide-11"> </div>
          </div>
        </div>
      </div>
      <!-- If we need pagination -->
      <div class="swiper-pagination"></div>

      <!-- If we need navigation buttons -->
      <div class="swiper-button-prev">
        <font-awesome-icon :icon="['fas', 'arrow-left']" size="xl" />
      </div>
      <div class="swiper-button-next">
        <font-awesome-icon :icon="['fas', 'arrow-right']" size="xl" />
      </div>
      <!-- If we need scrollbar -->
      <div class="d-none swiper-scrollbar"></div>
    </div>
  </div>
</template>

<script>
import Navigation from 'swiper/modules/navigation/navigation.js';
import Pagination from 'swiper/modules/pagination/pagination.js';
import Scrollbar from 'swiper/modules/scrollbar/scrollbar.js';
import A11y from 'swiper/modules/a11y/a11y.js';

// Import Swiper Vue.js components
import Swiper from 'swiper/core/core.js';

import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/scrollbar/scrollbar.min.css';

// Import Swiper styles
import 'swiper/swiper.min.css';
import GoogleService from "../services/google.service";
import SmartCenterService from "../services/smart.center.service";

export default {
  name: "SalesGrowthUniversity",
  mixins: [],
  components: {
 },
  data() {
    return {
        title: "Welcome Slider",
        keyConceptsLink: "",
    };
  },
  
  props: {},
  computed: {},
  mounted() {
    let swiper = new Swiper(this.$refs.swiper, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination, Scrollbar, A11y],
      // Optional parameters
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    let vm = this;
    swiper.on('slideChange', function () {
      var currentSlide = this.realIndex + 1;
      vm.$emit("setTitle", currentSlide);
    });      
  },
  created() {},
  methods: {},
  watch: {},
};
</script>
